import styled from 'styled-components';
import { Toggle } from 'ui/toggle';
import { InputSearch } from 'ui/inputs';
import { heading4, spacing, button, colors } from 'ui/theme';
import { pxToRem } from 'utils/convert';
import { CSVButton } from './CSVButton';
import { useSnippetsContext } from '../context';

export const SNIPPETS_TABLE_HEADER_TEST_ID = 'snippets-table-header';
export const SNIPPETS_SEARCH_ID = 'snippets-search';

const MainHeader = styled.div`
  ${heading4};
  align-items: center;
  display: flex;
  justify-content: space-between;
  padding: ${spacing.base} ${spacing.double};
`;
const ActionContainer = styled.div`
  display: flex;
  gap: ${spacing.half};
`;

export const WideInputSearch = styled(InputSearch)`
  width: ${pxToRem(300)};
`;

type ToggleWrapperProps = {
  showCampaigns: boolean;
};

export const ToggleWrapper = styled.div<ToggleWrapperProps>`
  display: flex;
  align-items: center;
  ${button};
  cursor: pointer;
  border: ${({ showCampaigns }) =>
    showCampaigns
      ? `${spacing.single} solid ${colors.green50}`
      : `${spacing.single} solid ${colors.grey15}`};
  padding: ${spacing.half};
  gap: ${spacing.threeQuarter};
  border-radius: ${spacing.quarter};
`;

export const TableHeader = ({ showCampaignToggle }: { showCampaignToggle?: boolean }) => {
  const { searchTerm, handleSearch, setShowCampaigns, showCampaigns } = useSnippetsContext();
  return (
    <MainHeader data-test={SNIPPETS_TABLE_HEADER_TEST_ID}>
      <span>Snippets</span>
      <ActionContainer>
        <WideInputSearch
          id={SNIPPETS_SEARCH_ID}
          data-test={SNIPPETS_SEARCH_ID}
          placeholder={'Search snippets...'}
          onChange={handleSearch}
          value={searchTerm}
        />
        {showCampaignToggle && (
          <ToggleWrapper
            onClick={() => setShowCampaigns(!showCampaigns)}
            showCampaigns={showCampaigns}
          >
            <span>Campaign view</span>
            {/* eslint-disable-next-line @typescript-eslint/no-empty-function */}
            <Toggle onClick={() => {}} isActive={showCampaigns} />
          </ToggleWrapper>
        )}
        <CSVButton />
      </ActionContainer>
    </MainHeader>
  );
};
